import { useState, React } from 'react';
import employees from '../data/employees';
import Slider from 'react-slick';
import './About.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const About = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        centerPadding: '0',
    };

    const AccordionItem = ({ title, content }) => {
        const [isOpen, setIsOpen] = useState(false);

        return (
            <div className="accordion-item" style={{ borderBottom: "1px solid rgb(158, 158, 158)", paddingBottom: "10px" }}>
                <h2
                    style={{ cursor: "pointer", fontSize: "20px", color: "#883001" }}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {title}
                </h2>
                {isOpen && <p style={{ fontSize: "18px", marginTop: "5px" }}>{content}</p>}
            </div>
        );
    };

    const conditions = [
        { title: "Sciatica and Back Pain Relief", content: "Sciatica and back pain can be alleviated through targeted physical therapy exercises, manual therapy, and posture correction to reduce nerve compression and improve mobility." },
        { title: "Headaches and Neck Pain Relief", content: "Physical therapy for headaches and neck pain includes stretching, strengthening exercises, and ergonomic adjustments to relieve tension and improve alignment." },
        { title: "Shoulder Pain Relief", content: "Shoulder pain can be treated with therapeutic exercises, manual therapy, and modalities like ultrasound to reduce inflammation and restore function." },
        { title: "Hip and Knee Pain Relief", content: "Hip and knee pain relief involves strengthening surrounding muscles, improving joint mobility, and using techniques like gait training to enhance movement." },
        { title: "Elbow, Wrist, and Hand Pain Relief", content: "Treatment includes exercises to improve strength and flexibility, ergonomic adjustments, and manual therapy to address pain and dysfunction." },
        { title: "Foot and Ankle Pain Relief", content: "Physical therapy for foot and ankle pain focuses on balance training, strengthening, and mobility exercises to restore function and reduce discomfort." },
        { title: "Motor Vehicles Injuries", content: "Rehabilitation for motor vehicle injuries includes personalized exercise programs, manual therapy, and pain management techniques to aid recovery." },
        { title: "Balance and Gait Training", content: "Balance and gait training involves exercises to improve stability, coordination, and strength, helping to prevent falls and enhance mobility." },
        { title: "Pain Relief for Arthritis", content: "Arthritis pain relief includes joint mobilization, strengthening exercises, and low-impact activities to reduce stiffness and improve function." },
        { title: "Chronic Pain Relief", content: "Chronic pain management involves a combination of therapeutic exercises, relaxation techniques, and education to improve quality of life." },
        { title: "Pre-Surgical Rehab", content: "Pre-surgical rehab prepares the body for surgery through strengthening and conditioning exercises, improving outcomes and recovery time." },
        { title: "Post-Surgical Rehab", content: "Post-surgical rehab focuses on restoring strength, mobility, and function through guided exercises and manual therapy." },
        { title: "Neurological Disorders", content: "Treatment for neurological disorders includes balance training, coordination exercises, and functional mobility improvement to enhance independence." },
        { title: "Sports Injuries", content: "Sports injury rehabilitation involves targeted exercises, manual therapy, and sport-specific training to return to activity safely." },
        { title: "Vestibular Rehab", content: "Vestibular rehabilitation includes exercises to reduce dizziness, improve balance, and address inner ear disorders." },
        { title: "Work Injuries", content: "Work injury recovery focuses on ergonomic assessments, strengthening exercises, and functional training to return to work safely." },
    ];

    const howWeTreat = [
        { title: "Myofascial Release", content: "Myofascial release is a hands-on technique that focuses on relieving tension in the connective tissues to improve mobility and reduce pain." },
        { title: "Manual Therapy", content: "Manual therapy involves skilled hand movements to mobilize joints and soft tissues, enhancing range of motion and reducing discomfort." },
        { title: "Rapid Release Technology", content: "Rapid Release Technology uses high-frequency vibration to target scar tissue and adhesions, promoting faster recovery and pain relief." },
        { title: "Injury Prevention Screening", content: "Injury prevention screening identifies potential risk factors and provides personalized strategies to reduce the likelihood of injuries." },
        { title: "Taping", content: "Taping techniques, such as kinesiology taping, support muscles and joints, improve circulation, and aid in recovery from injuries." },
    ];

    return (
        <div>
            <div className="about-container">
                <div className="banner">
                    <h1>Meet Our World Class Team!</h1>
                </div>
                <Slider {...settings} className="employee-gallery" style={{}}>
                    {employees.map((employee, index) => (
                        <div key={index} className="employee-card">
                            <img src={employee.image} alt={employee.name} className="employee-image" />
                            <div className="employee-info">
                                <h2>{employee.name}</h2>
                                <p>{employee.bio}</p>
                            </div>
                        </div>
                    ))}
                </Slider>
                <div className="mission-statement" style={{ marginTop: "25px" }}>
                    <h1 style={{ paddingBottom: "15px", borderBottom: "1px solid rgb(158, 158, 158)" }}>Our Mission</h1>
                    <p style={{ fontSize: "20px" }}>At Fritz Physical Therapy, our mission is to provide personalized, evidence-based care to help our clients achieve their health and wellness goals. We are committed to fostering a supportive and inclusive environment where everyone feels valued and empowered.</p>
                </div>
                <div className="what-we-treat">
                    <h1 style={{ paddingBottom: "15px", borderBottom: "1px solid rgb(158, 158, 158)" }}>What We Treat</h1>
                    <div className="accordion">
                        {conditions.map((condition, index) => (
                            <AccordionItem key={index} title={condition.title} content={condition.content} />
                        ))}
                    </div>
                </div>
                <div className="how-we-treat">
                    <h1 style={{ paddingBottom: "15px", borderBottom: "1px solid rgb(158, 158, 158)" }}>How We Treat</h1>
                    <div className="accordion">
                        {howWeTreat.map((treatment, index) => (
                            <AccordionItem key={index} title={treatment.title} content={treatment.content} />
                        ))}
                    </div>
                </div>
                <div className="testimonials">
                    <h1 style={{ paddingBottom: "15px", borderBottom: "1px solid rgb(158, 158, 158)" }}>What Our Clients Say</h1>
                    <br></br><p style={{ fontSize: "18px" }}><i>"I came to Fritz after a shoulder SLAP tear surgery (bicep tenodesis) for rehabilitation to get me back to playing volleyball. Having come here for 15 weeks, they have gotten me able to start back into volleyball gradually and weight room work. Not just my physical therapist (shout-out Jill for being awesome), but everyone here is fantastic; Zach, Ava, Dan, and Catherine all made a difference in my treatment and progress, too! Highly recommend for all the reasons!" - Eric Turcovski</i></p>
                    <br></br><p style={{ fontSize: "18px" }}><i>"I am so grateful for Summer, who made me feel so much better. Several weeks ago my leg burned and was very painful. Today my leg is pain free. Summer showed me how to keep it that way with a daily routine. I highly recommend Fritz Physical Therapy. They are friendly & highly qualified." - Onnie Costanzo </i></p>
                </div>
            </div>
        </div>
    );
};

export default About;